module.exports = __webpack_public_path__ + "static/img/declaration.d847692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/declaration.png
// module id = QcXz
// module chunks = 29